import { render, staticRenderFns } from "./PerformanceLogo.vue?vue&type=template&id=a46a8dda&"
import script from "./PerformanceLogo.vue?vue&type=script&lang=ts&"
export * from "./PerformanceLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports